import React, { type FC, useState, useEffect } from 'react';
import { SelectField } from '@is24at/react-ui-core/Form';
import { SearchParamsEnum, SortLabels, SortValues } from 'utils/enums';
import styles from './SortFilter.scss';

type Props = {
  initialSortValue: any;
  reloadByUpdatingSort: (sortValue: any) => void;
};

const SortFilter: FC<Props> = ({ initialSortValue, reloadByUpdatingSort }) => {
  const [sort, setSort] = useState(initialSortValue);
  const sortOptions = SortValues.map((value: any) => ({
    value,
    label: SortLabels[value],
  }));

  useEffect(() => {
    reloadByUpdatingSort(sort);
    // Having `reloadByUpdatingSort` as part of this dependency array causes
    // an infinite rendering loop.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sort]);

  return (
    <SelectField
      fieldProps={{
        name: SearchParamsEnum.sort,
        value: sort,
        className: styles.sort__select,
        'data-testid': SearchParamsEnum.sort,
        onChange: (event) => setSort(event.target.value),
      }}
      options={sortOptions}
      containerProps={{
        className: styles['sort__select-container'],
      }}
    />
  );
};

export default SortFilter;
